import React from "react";
import { FormattedMessage } from "react-intl";
import { FlexContainer, ModalTitle, Text } from "../../shared/styles";
import { messages } from "./messages";
import { formatVisualDate } from "../../helpers/dates";

interface Props {
  recentlyUsedDates: string[];
  onClick: (date: Date) => void;
}

export const RecentlyUsedDates = ({ recentlyUsedDates, onClick }: Props): JSX.Element => (
  <>
    <ModalTitle>
      <FormattedMessage {...messages.recentlyUsedDates} />
    </ModalTitle>
    <FlexContainer>
      {recentlyUsedDates.map((usedDate, idx) =>
        <Text key={idx} onClick={() => onClick(new Date(usedDate))}>
          {formatVisualDate(usedDate)}
        </Text>
      )}
    </FlexContainer>
  </>
);